import React from 'react'
import InfoModal from 'asterX-UI/Modals/InfoModal'
import { useTranslation } from 'react-i18next'
import {
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles
} from '@material-ui/core'
import { generateUuid } from 'lib/utils'
import { FutureIconContainer, LockedIcon, UnlockedIcon } from 'asterX-UI/Icons'
const useStyle = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1)
  }
}))
const namespace = 'profilePage.profileFields.listUsersByIINModal.'
const uuId = generateUuid()
const ListUsersByIINModal = ({ open, onClose, users = [] }) => {
  const { t } = useTranslation()
  const classes = useStyle()
  return (
    <InfoModal
      open={open}
      onClose={onClose}
      variant={'info'}
      title={t(namespace + 'title')}
      btnText={t(namespace + 'close')}
    >
      <List className={classes.root}>
        {users?.map(item => (
          <React.Fragment key={uuId + '_user'}>
            <ListItem button>
              <ListItemText
                primary={`${item.firstName} ${item.lastName}`}
                secondary={item.username}
              />
              <ListItemSecondaryAction>
                <FutureIconContainer
                  color={item.isActive ? 'success' : 'secondary'}
                >
                  {item.isActive ? <UnlockedIcon /> : <LockedIcon />}
                </FutureIconContainer>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
          </React.Fragment>
        ))}
      </List>
    </InfoModal>
  )
}
export default ListUsersByIINModal
